import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { MOB_ICONS } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import FeeLink from "./feeLink";

import ShortLinkIcon from "./shortLinkIcon";

const ShortLinks = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [circularCount, setCircularCount] = useState(0);

  useEffect(() => {
    /*context.allowedAccess("mob_allow_circular", "action_list")
      ? loadData()
      : "";*/
  }, []);

  const loadData = () => {
    const form = new FormData();
    form.append("type", "student");
    form.append("course", context.user.course);
    form.append("uuid", context.user.student_uuid);
    axios.post(ServiceUrl.MOB.ANNOUNCEMENT_COUNT, form).then((res) => {
      if (res["data"].status == "1") {
        setCircularCount(
          parseInt(res["data"].data.count) -
            parseInt(res["data"].data.history_count),
        );
      } else {
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg text-uppercase fw-bold">
          My College
        </Card.Header>
        <Card.Body className="p-0">
          <Row className="mt-0 g-1">
            {context.allowedAccess(
              "stu_mob_view_attendance",
              "action_read",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/my-attendance"
                  title="Attendance"
                  icon={MOB_ICONS.ATTENDANCE_IMG}
                />
              </Col>
            )}
            {context.allowedAccess("stu_mob_allow_fees", "action_list") && (
              <FeeLink />
            )}
            {/*{context.allowedAccess(
              "stu_mob_allow_exam_fees",
              "action_list"
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/exam-fees"
                  title="Exam Fees"
                  icon={MOB_ICONS.EXAM_FEES_IMG}
                />
              </Col>
            )} */}

            <Col md={3} xs={4} sm={4}>
              <ShortLinkIcon
                link="/stu/app/my-profile"
                title="My Profile"
                icon={MOB_ICONS.MY_PROFILE_IMG}
              />
            </Col>

            {context.allowedAccess(
              "mob_allow_library_search",
              "action_list",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/library"
                  title="Library"
                  icon={MOB_ICONS.LIBRARY}
                />
              </Col>
            )}
            {/* {context.allowedAccess("mob_allow_circular", "action_list") && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/circular"
                  title="Circular"
                  icon={MOB_ICONS.CIRCULAR}
                />
              </Col>
            )} */}

            {context.allowedAccess(
              "stu_mob_allow_service_requests",
              "action_list",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/service"
                  title="Service"
                  icon={MOB_ICONS.LEAVE}
                />
              </Col>
            )}

            {context.allowedAccess(
              "stu_mob_allow_student_feedback",
              "action_list",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/feedback"
                  title="Feedback"
                  icon={MOB_ICONS.FEEDBACK}
                />
              </Col>
            )}
            {/* {context.allowedAccess(
              "stu_mob_allow_student_hallticket",
              "action_list"
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/hallticket"
                  title="HallTicket"
                  icon={MOB_ICONS.STUDENTHALLTICKET}
                />
              </Col>
            )}

            {context.allowedAccess(
              "stu_mob_allow_student_elective",
              "action_list"
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/elective"
                  title="Elective"
                  icon={MOB_ICONS.ELECTIVE_ICON}
                />
              </Col>
            )}

            {context.allowedAccess(
              "mob_stu_transport_request",
              "action_list"
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/transport-request"
                  title="Transport Request"
                  icon={MOB_ICONS.TRANSPORT_REQUEST_512}
                />
              </Col>
            )} */}

            {context.allowedAccess(
              "stu_mob_allow_student_results",
              "action_list",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/exam-results"
                  title="Results"
                  icon={MOB_ICONS.EXAM_RESULTS_ICON}
                />
              </Col>
            )}

            {context.allowedAccess(
              "stu_mob_allow_student_idcard",
              "action_list",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/studentidcard"
                  title="ID Card"
                  icon={MOB_ICONS.IDCARD}
                />
              </Col>
            )}
            {/* {context.allowedAccess(
              "stu_mob_allow_student_idcard",
              "action_list"
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/admission-card"
                  title="Admission Form"
                  icon={MOB_ICONS.ATT_REPORT_256}
                />
              </Col>
            )}

            {context.allowedAccess(
              "stu_mob_allow_student_idcard",
              "action_list"
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/track-order-status"
                  title="Track Payment"
                  icon={MOB_ICONS.TRACK_STATUS}
                />
              </Col>
            )} */}

            {context.allowedAccess(
              "stu_mob_allow_sem_admission_form",
              "action_list",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/admission-card"
                  title="Admission Form"
                  icon={MOB_ICONS.ATT_REPORT_256}
                />
              </Col>
            )}

            {context.allowedAccess(
              "stu_mob_allow_track_payment",
              "action_list",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/track-order-status"
                  title="Track Payment"
                  icon={MOB_ICONS.TRACK_STATUS}
                />
              </Col>
            )}

            {context.allowedAccess(
              "stu_mob_allow_online_transfer",
              "action_list",
            ) && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/online-transfer"
                  title="Online Transfer"
                  icon={MOB_ICONS.STUDENT_TRANSFER}
                />
              </Col>
            )}

            {context.allowedAccess("stu_mob_subject_target", "action_list") && (
              <Col md={3} xs={4} sm={4}>
                <ShortLinkIcon
                  link="/stu/app/targetsettigs"
                  title="Target Settings"
                  icon={MOB_ICONS.TARGET_SETING}
                />
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};
export default ShortLinks;
